import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
var _DarkTheme5_;
import { createTheme, markThemeVersion } from "../../../lib/theming/ThemeHelpers";
import { BasicThemeClassForExtension } from "../BasicTheme";
import { DarkTheme5_4 } from "../DarkTheme5_4";
export var DarkTheme5_5 = createTheme({
  themeClass: (_DarkTheme5_ = /*#__PURE__*/function (_BasicThemeClassForEx) {
    function DarkTheme5_5() {
      return _BasicThemeClassForEx.apply(this, arguments) || this;
    }
    _inheritsLoose(DarkTheme5_5, _BasicThemeClassForEx);
    return _createClass(DarkTheme5_5, null, [{
      key: "fileUploaderIconHoverColorForValidation",
      get: function get() {
        return this.bgSecondary;
      }
    }, {
      key: "fileUploaderErrorColor",
      get: function get() {
        return this.textColorDisabled;
      }
    }, {
      key: "fileUploaderErrorTextColor",
      get: function get() {
        return this.errorText;
      }
    }, {
      key: "fileUploaderValidationTextColor",
      get: function get() {
        return this.fileUploaderTextColorDefault;
      }
    }, {
      key: "fileUploaderAfterLinkColor",
      get: function get() {
        return this.gray;
      }
    }, {
      key: "fileUploaderBorderColor",
      get: function get() {
        return this.borderColorGrayLight;
      }
    }, {
      key: "fileUploaderDisabledTextColor",
      get: function get() {
        return this.fileUploaderDisabledColor;
      }
    }, {
      key: "fileUploaderDisabledFileTypeIcon",
      get: function get() {
        return this.fileUploaderDisabledIconColor;
      }
      //#endregion FileUploader
    }]);
  }(BasicThemeClassForExtension), _DarkTheme5_.fileUploaderIconColorForValidation = '#222222', _DarkTheme5_.fileUploaderFileTypeUnknownIconColor = '#676767', _DarkTheme5_.fileUploaderPaddingXSmall = '7px', _DarkTheme5_.fileUploaderPaddingXMedium = '9px', _DarkTheme5_.fileUploaderPaddingXLarge = '11px', _DarkTheme5_.fileUploaderErrorBgColor = '#4F2421', _DarkTheme5_.fileUploaderErrorBgHoverColor = '#612A29', _DarkTheme5_.fileUploaderWarningBgColor = '#3F2F1E', _DarkTheme5_.fileUploaderWarningBgHoverColor = '#4C3923', _DarkTheme5_.fileUploaderWarningTextColor = '#FDD481', _DarkTheme5_.fileUploaderDisabledColor = 'rgba(255, 255, 255, 0.54)', _DarkTheme5_.fileUploaderDisabledIconColor = 'rgba(255, 255, 255, 0.32)', _DarkTheme5_),
  prototypeTheme: DarkTheme5_4,
  themeMarkers: [markThemeVersion('5.5')]
});